/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { calculateAge } from 'util/date/calculateAge'
import { humanizeAge } from 'util/date/humanize-age'

import { MCHAT_RESULTADOS } from '../../../objetivo/puericultura/mchat-rf/mchat/model-mchat'
import { RegistroMChatAcompanhamentoPuericultura } from '../model'

interface MChatAcompanhamentoPuericulturaAccordionPanelProps {
  registroMChat: RegistroMChatAcompanhamentoPuericultura
  cidadaoDataNascimento: LocalDate
}

export function MChatAcompanhamentoPuericulturaAccordionPanel(
  props: MChatAcompanhamentoPuericulturaAccordionPanelProps
) {
  const { registroMChat, cidadaoDataNascimento } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const { encaminhamento } = MCHAT_RESULTADOS[registroMChat.risco]
  const idadeCidadao = humanizeAge(cidadaoDataNascimento, registroMChat.dataResultado)
  const { ageInMonths } = calculateAge(cidadaoDataNascimento, registroMChat.dataResultado)

  return (
    <div css={styles.root}>
      <VFlow vSpacing={0.5}>
        <Alert inline type='info'>
          É possível visualizar a avaliação completa com as perguntas e respostas a partir da impressão do registro.
        </Alert>
        <HLabel title='Idade da criança na avaliação:'>{idadeCidadao}</HLabel>
        <HLabel title='Encaminhamento:'>
          <Text style={styles.encaminhamentoText} dangerouslySetInnerHTML={{ __html: encaminhamento(ageInMonths) }} />
        </HLabel>
      </VFlow>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    padding: 1rem;
    background: ${theme.pallete.gray.c90};
  `,
  encaminhamentoText: css`
    & > strong {
      font-weight: normal;
    }
  `,
})
